import axios from "axios";
import BASE_URL from "../_helpers/constants";
import { readCurrentUser } from "../_helpers/currentUser";

// Pooled inbox SP5 — every /api/billing/* call the web makes (contract:
// Astra-Backend docs/superpowers/plans/2026-10-04-pooled-inbox-sp5-backend.md,
// B3 and B4 Interfaces). The onboarding.services.js style: each returns the
// axios response and throws on a non-2xx; callers read `res.data` and
// `err.response.data`. No amount is ever sent: the server prices everything.
const authHeaders = () => ({
  Authorization: `Bearer ${readCurrentUser()?.token ?? ""}`,
});

// ---- Plans and the account --------------------------------------------------------
// { plans: [{ id, tier, name, description, priceCents, currency, interval,
//   features, appleProductId }], freeMonth, setupFee: { cents, waived },
//   addOnMeetingPriceCents }
export const getPlans = () =>
  axios.get(`${BASE_URL}/billing/plans`, { headers: authHeaders() });

// { entitlement, pendingPlan: { id, name, priceCents } | null,
//   card: { brand, last4, expMonth, expYear } | null, manageUrl,
//   lastPaymentFailed, appAccountToken }
export const getBillingMe = () =>
  axios.get(`${BASE_URL}/billing/me`, { headers: authHeaders() });

// ---- Choose a plan, save a card for $0, start the free month ------------------------
export const choosePlan = (planId) =>
  axios.post(
    `${BASE_URL}/billing/plan`,
    { planId },
    { headers: authHeaders() },
  );

export const createSetupIntent = () =>
  axios.post(
    `${BASE_URL}/billing/setup-intent`,
    {},
    { headers: authHeaders() },
  );

export const startTrial = (setupIntentId) =>
  axios.post(
    `${BASE_URL}/billing/start-trial`,
    { setupIntentId },
    { headers: authHeaders() },
  );

// ---- Profile: change plan, cancel, a new card -----------------------------------------
export const changePlan = (planId) =>
  axios.patch(
    `${BASE_URL}/billing/plan`,
    { planId },
    { headers: authHeaders() },
  );

export const cancelPlan = () =>
  axios.post(`${BASE_URL}/billing/cancel`, {}, { headers: authHeaders() });

export const createCardSetupIntent = () =>
  axios.post(
    `${BASE_URL}/billing/card/setup-intent`,
    {},
    { headers: authHeaders() },
  );

export const saveCard = (setupIntentId) =>
  axios.post(
    `${BASE_URL}/billing/card`,
    { setupIntentId },
    { headers: authHeaders() },
  );

// ---- Admin Packages (super-admin) -------------------------------------------------------
// { plans: [{ id, name, tier, stripePriceId, stripeStatus, reason }], notices }
export const getBillingCatalog = () =>
  axios.get(`${BASE_URL}/billing/admin/catalog`, { headers: authHeaders() });
